import { RECEIVE_USER_ADDRESSES, REQUEST_USER_ADDRESSES } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        items: [],
        isFetching: null,
        fetchSuccessful: null,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_USER_ADDRESSES:
            return { ...state, isFetching: true }

        case RECEIVE_USER_ADDRESSES: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
